import { Photo } from '../../app/base/entities/photo.interface';
import { InMemoryPhotoV2, PhotoType } from '../../app/base/entities/photo';

export interface RequestRecord {
  type: EntityType | PhotoType; // Typing to be improved in a future refactoring.
  entity: Entity;
  request: RequestData;
  retry: Retry;
  label: string;
}

export interface PhotoRequestRecord extends Omit<RequestRecord, 'label'> {
  photo: Photo | InMemoryPhotoV2;
}

export enum EntityType {
  ISSUE = 'ISSUE'
}

export interface Retry {
  status: RetryStatus;
  count: number;
}

export enum RetryStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}

export const RETRY_PENDING = () => ({ ...{ status: RetryStatus.PENDING, count: 0 } });

export interface RequestData {
  body?: Object;
  url: string;
  method: 'GET' | 'POST';
  responseType: 'json' | 'text';
  queryParams?: { [key: string]: string };
  headers: { [key: string]: string };
}

export interface Entity {
  id: string;
  timestamp: Date; // Unused?
}
